import React from "react";
import styles from "../components/laymanComp_css/LaymanPage18.module.css";
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/elohim.json";

export default function LaymanPage18_elohim() {
  return (
    <>
   <Common_html BlockData={BlockData} />
    </>
  );
}